import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'zwi-headline',
    templateUrl: './headline.component.html',
    styleUrls: ['./headline.component.scss'],
    standalone: false
})
export class HeadlineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
